import format from "~/utils/formatter"
export default defineNuxtPlugin( () => {
    return { provide: { format }}
  })